import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

// Fetches per-day inbound/outbound call graph data
export const fetchCallGraph = createAsyncThunk(
  "dashboard/fetchCallGraph",
  async ({ startDate, endDate } = {}, { rejectWithValue }) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate)   params.endDate   = endDate;
      const res = await api.get("/call/inbound-outbound-call-graph", { params });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetches call-status breakdown (answered / missed / cancelled / invalid)
export const fetchDashboardCallHistory = createAsyncThunk(
  "dashboard/fetchDashboardCallHistory",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const res = await api.post("/call/dashboard-call-history", { startDate, endDate });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dashboardDataSlice = createSlice({
  name: "dashboardData",
  initialState: {
    callGraph:      null,
    callHistory:    null,
    loadingGraph:   true,
    loadingHistory: true,
    errorGraph:     null,
    errorHistory:   null,
  },
  reducers: {
    // Lets retry effects restore the skeleton while waiting to re-fire the fetch,
    // so the 2 s retry window doesn't flash 0s to the user.
    setGraphLoading:   (state) => { state.loadingGraph   = true; },
    setHistoryLoading: (state) => { state.loadingHistory = true; },
  },
  extraReducers: (builder) => {
    builder
      // ── callGraph ──────────────────────────────────────────────────────────
      .addCase(fetchCallGraph.pending, (state) => {
        state.loadingGraph = true;
        state.errorGraph   = null;
      })
      .addCase(fetchCallGraph.fulfilled, (state, action) => {
        state.loadingGraph = false;
        state.callGraph    = action.payload ?? null;
      })
      .addCase(fetchCallGraph.rejected, (state, action) => {
        state.loadingGraph = false;
        state.errorGraph   = action.payload;
        // Keep existing callGraph on error so a transient failure doesn't blank
        // a previously-loaded chart.
      })

      // ── callHistory ────────────────────────────────────────────────────────
      .addCase(fetchDashboardCallHistory.pending, (state) => {
        state.loadingHistory = true;
        state.errorHistory   = null;
      })
      .addCase(fetchDashboardCallHistory.fulfilled, (state, action) => {
        state.loadingHistory = false;
        state.callHistory    = action.payload ?? null;
      })
      .addCase(fetchDashboardCallHistory.rejected, (state, action) => {
        state.loadingHistory = false;
        state.errorHistory   = action.payload;
        // Keep existing callHistory on error.
      });
  },
});

export const { setGraphLoading, setHistoryLoading } = dashboardDataSlice.actions;
export default dashboardDataSlice.reducer;
